import hashClear from "./_hashClear.js";
import hashDelete from "./_hashDelete.js";
import hashGet from "./_hashGet.js";
import hashHas from "./_hashHas.js";
import hashSet from "./_hashSet.js";
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index < length; ) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
export {
  Hash as default
};
//# sourceMappingURL=_Hash.js.map
